import constants from "../utils/Constants";
import { getData, postData, putData } from "./rest-api-helper";


export async function getProjByComServ({ comId, limit, pageNumber, searchWord, type, userId, userType }) {
    if (userType === constants.sourcing) {
        const details = {
            urlPath: "/source/company/projects",
            queryParams: {
                ...(userId && { sourceUserId: userId }),
                ...(searchWord && { searchWord }),
                ...(limit && { limit }),
                ...(pageNumber && { offset: (pageNumber * limit) - limit }),
                ...(comId && { comId }),
            }
        }
        const res = await getData(details);
        return res.data;
    } else if (type === "com") {
        const details = {
            urlPath: "/projects/byUser",
            queryParams: {
                ...(userId && { userId }),
                ...(searchWord && { searchWord }),
                ...(limit && { limit }),
                ...(pageNumber && { offset: (pageNumber * limit) - limit }),

            }
        }
        const res = await getData(details);
        return res.data;
    } else {
        const details = {
            urlPath: "/projects/byCom",
            queryParams: {
                ...(comId && { comId }),
                ...(searchWord && { searchWord }),
                ...(limit && { limit }),
                ...(pageNumber && { offset: (pageNumber * limit) - limit }),

            }
        }
        const res = await getData(details);
        return res.data;
    }
}

export async function getSingleProjServ(projIdStrg) {
    const details = {
        urlPath: `/projects/single/${projIdStrg}`
    }
    const res = await getData(details);
    return res.data;
}

export async function createProjServ(data) {
    const details = {
        urlPath: "/projects",
        body: {
            ...data
        }
    }
    const res = await postData(details);
    return res;
}

export async function createProjUserServ(data) {
    const details = {
        urlPath: "/projects/createUser",
        body: {
            ...data
        }
    }
    const res = await postData(details);
    return res;
}

export async function getProjDDByComServ({ comId }) {
    const details = {
        urlPath: "/projects/forDD",
        queryParams: {
            comId
        }
    }
    const res = await getData(details);
    return res.data;
}

export async function editProjUser(data, userId, type) {
    if (type === "proj") {
        const details = {
            urlPath: `/projects/editUser/${userId}`,
            body: {
                ...data
            }
        }
        const res = await putData(details);
        return res;
    } else {
        const details = {
            urlPath: `/departments/editUser/${userId}`,
            body: {
                ...data
            }
        }
        const res = await putData(details);
        return res;
    }

}

export async function rmvProjFromUserServ(data) {
    const details = {
        urlPath: `/projects/rmvProjFromUser`,
        body: {
            ...data
        }
    }
    const res = await putData(details);
    return res;
}

export async function assignProjUserServ({ userId, comId, projIdStrg }) {
    const details = {
        urlPath: `/projects/assignProjUser`,
        body: {
            userId, comId, projIdStrg
        }
    }
    const res = await putData(details);
    return res;
}

export async function editProjServ(data, projIdStrg) {
    const details = {
        urlPath: `/projects/editProj/${projIdStrg}`,
        body: {
            ...data
        }
    }
    const res = await putData(details);
    return res;
}

export async function setProjAmtLimitServ(data) {
    const details = {
        urlPath: `/projects/setProjAmtLimit`,
        body: {
            ...data
        }
    }
    const res = await putData(details);
    return res;
}